/* お気に入りログインモーダルの表示制御を共有する */
(() => {
  if (window.AuremeWishlistLoginModal) return;

  const LOGIN_MODAL_SELECTOR = '[data-aureme-wishlist-login-modal]';
  const LOGIN_MODAL_CONTENT_SELECTOR = '.aureme-wishlist-login-modal__content';
  const LOGIN_MODAL_CLOSE_SELECTOR = '[data-aureme-wishlist-login-modal-close]';
  const LOGIN_MODAL_OPEN_BODY_CLASS = 'aureme-wishlist-login-modal-open';
  const LOGIN_MODAL_SHOW_CLASS = 'is-show';
  let activeModal = null;
  let modalOpener = null;

  function findScopedModal(opener = null) {
    if (opener instanceof Element) {
      for (let scope = opener; scope; scope = scope.parentElement) {
        if (scope.matches(LOGIN_MODAL_SELECTOR)) return scope;

        const modal = scope.querySelector(LOGIN_MODAL_SELECTOR);
        if (modal) return modal;
      }
    }

    return document.querySelector(LOGIN_MODAL_SELECTOR);
  }

  function getOpenModal() {
    if (activeModal?.classList.contains(LOGIN_MODAL_SHOW_CLASS)) return activeModal;

    return document.querySelector(`${LOGIN_MODAL_SELECTOR}.${LOGIN_MODAL_SHOW_CLASS}`);
  }

  function isOpen() {
    return Boolean(getOpenModal());
  }

  function open(opener = null) {
    const modal = findScopedModal(opener);
    const modalContent = modal?.querySelector(LOGIN_MODAL_CONTENT_SELECTOR);
    if (!modal || !modalContent) return false;

    activeModal = modal;
    modalOpener = opener instanceof HTMLElement ? opener : document.activeElement;
    modal.classList.add(LOGIN_MODAL_SHOW_CLASS);
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add(LOGIN_MODAL_OPEN_BODY_CLASS);

    /* ログイン導線へ誘導するモーダルなので、開いている間は内部へフォーカスを閉じ込める */
    if (typeof trapFocus === 'function' && typeof getFocusableElements === 'function') {
      const initialFocusTarget = getFocusableElements(modalContent)[0];
      if (initialFocusTarget) {
        trapFocus(modalContent, initialFocusTarget);
      }
    }

    return true;
  }

  function close(modal = getOpenModal()) {
    if (!modal) return;

    modal.classList.remove(LOGIN_MODAL_SHOW_CLASS);
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(LOGIN_MODAL_OPEN_BODY_CLASS);

    const focusTarget =
      modalOpener instanceof HTMLElement && modalOpener.isConnected ? modalOpener : null;

    /* trap を解除したうえで、閉じる前に操作していたボタンへ戻す */
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusTarget);
    } else if (focusTarget) {
      focusTarget.focus();
    }

    if (activeModal === modal || !getOpenModal()) {
      activeModal = null;
      modalOpener = null;
    }
  }

  function handleClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const closeTarget = target.closest(LOGIN_MODAL_CLOSE_SELECTOR);
    if (!closeTarget) return;

    close(closeTarget.closest(LOGIN_MODAL_SELECTOR) || undefined);
  }

  function handleKeydown(event) {
    if (event.key !== 'Escape' || !isOpen()) return;

    event.preventDefault();
    close();
  }

  window.AuremeWishlistLoginModal = {
    close,
    isOpen,
    open,
  };

  document.addEventListener('click', handleClick);
  document.addEventListener('keydown', handleKeydown);
})();
